@if (toast) {
  <div class="response-toast" [class.response-toast--leaving]="toast.leaving">
    <span class="response-toast-icon" aria-hidden="true">
      <i class="ph ph-check"></i>
    </span>
    {{ toast.message }}
  </div>
}
